import styled from '@emotion/styled'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle as MuiDialogTitle,
    Typography,
} from '@mui/material'
import React from 'react'

const StyledDialogActions = styled(DialogActions)`
    display: flex;
    justify-content: space-between;
    margin: 10px;
`

interface Props {
    icon?: React.ReactElement
    onCancel: () => void
    onSaveAndKeepBids: (event: React.FormEvent<any>) => void
    onSaveAndCancelBids: (event: React.FormEvent<any>) => void
    open: boolean
    title?: string
    postMessageEm?: string
    proxyBidCount?: number | null
}

enum CancelProxyDialogText {
    CONTINUE_EDITING = 'CONTINUE EDITING',
    SAVE_AND_KEEP_BIDS = 'SAVE & KEEP BIDS',
    SAVE_AND_CANCEL_BIDS = 'SAVE & CANCEL BIDS',
}

const proxyBidWording = (proxyBidCount: number | null | undefined = 0): string => {
    if (proxyBidCount === 1) {
        return `${proxyBidCount} proxy bid`
    }
    if (proxyBidCount === 2) {
        return `${proxyBidCount} proxy bids`
    }
    return `all ${proxyBidCount} proxy bids`
}

const CancelProxyDialog: React.VFC<Props> = ({
    icon,
    onCancel,
    onSaveAndCancelBids,
    onSaveAndKeepBids,
    open,
    title = 'Confirm',
    postMessageEm,
    proxyBidCount,
}: Props) => {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <MuiDialogTitle>
                {icon}
                <Typography variant="h6">{title}</Typography>
            </MuiDialogTitle>
            <DialogContent>
                <DialogContentText>
                    <>
                        You changed the condition of <em>{postMessageEm}</em>. Do you want to cancel&nbsp;
                        {proxyBidWording(proxyBidCount)} on this vehicle?
                    </>
                </DialogContentText>
            </DialogContent>
            <StyledDialogActions>
                <div>
                    <Button onClick={onCancel}>
                        <Typography variant="body1" color="primary">
                            {CancelProxyDialogText.CONTINUE_EDITING}
                        </Typography>
                    </Button>
                </div>
                <DialogActions style={{ display: 'flex' }}>
                    <Button onClick={onSaveAndKeepBids}>
                        <Typography variant="body1" color="primary">
                            {CancelProxyDialogText.SAVE_AND_KEEP_BIDS}
                        </Typography>
                    </Button>
                    <Button onClick={onSaveAndCancelBids} color="primary" autoFocus>
                        <Typography variant="body1" color="primary">
                            {CancelProxyDialogText.SAVE_AND_CANCEL_BIDS}
                        </Typography>
                    </Button>
                </DialogActions>
            </StyledDialogActions>
        </Dialog>
    )
}

export default CancelProxyDialog
